const TENDER_EDIT_STEPS = [
  { id: 1, label: 'Estimate' },
  { id: 2, label: 'Details' },
  { id: 3, label: 'Contractors' },
];

export default TENDER_EDIT_STEPS;
